import { palette } from '@hapana/shared/web/styles/material-ui/palette'

export const typography = {
  fontFamily: ['Outfit', '"Segoe UI"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),

  display: {
    fontWeight: 600,
    fontSize: 48,
  },
  header1: {
    fontWeight: 600,
    fontSize: 24,
  },
  header2: {
    fontWeight: 600,
    fontSize: 20,
  },
  header3: {
    fontWeight: 600,
    fontSize: 16,
  },
  header4: {
    fontWeight: 600,
    fontSize: 14,
  },
  header5: {
    fontWeight: 600,
    fontSize: 12,
  },
  large: {
    fontWeight: 400,
    fontSize: 16,
  },
  subtitle: {
    fontWeight: 400,
    fontSize: 14,
  },
  mediumP: {
    fontWeight: 400,
    fontSize: 14,
  },
  medium: {
    fontWeight: 400,
    fontSize: 14,
  },
  small: {
    fontWeight: 400,
    fontSize: 12,
  },
  button: {
    fontWeight: 600,
    fontSize: 14,
    textTransform: 'initial',
  },
  grayHeader4: {
    fontWeight: 600,
    fontSize: 14,
    color: palette.gray[64],
  },
  graySmall: {
    fontWeight: 400,
    fontSize: 12,
    color: palette.gray[64],
  },
}
